import { schema } from 'normalizr';
import * as AccountItem from 'app/react/entities/accounts/items/schemas';

export const ENTITY_REDUCER_KEY = 'bookingItems';
export const COLLECTION_REDUCER_KEY = ENTITY_REDUCER_KEY;

const fromAPI = AccountItem.processStrategy;

const entityDefinition = {};
const entityOptions = { processStrategy: fromAPI };

export const entity = new schema.Entity(ENTITY_REDUCER_KEY, entityDefinition, entityOptions);
export const entities = new schema.Array(entity);

export const toAPI = AccountItem.toAPI;
